import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthShopGuardService implements CanActivate {

  constructor(
    public auth: AuthService,
    public router: Router
  ) { }

  isLoggedIn: boolean = false;

  canActivate() {

    let shopToken = this.auth.getStoreToken();

    if (shopToken != null) {
      this.isLoggedIn = true;
    }

    if (!this.isLoggedIn) {
      this.router.navigate(['login']);
      return false;
    }

    return true;
  }
}
